import React, { useState, useEffect } from 'react';
import { FormField } from '@/shared/components/ui/FormField';
import { Input } from '@/shared/components/ui/Input';

interface ColorPickerFieldProps {
  label: string;
  description?: string;
  value: string;
  onChange: (value: unknown) => void;
}

export const ColorPickerField: React.FC<ColorPickerFieldProps> = ({
  label,
  description,
  value,
  onChange,
}) => {
  const [hexInput, setHexInput] = useState(value);

  useEffect(() => {
    setHexInput(value);
  }, [value]);

  const handleHexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setHexInput(v);
    // Vazio = limpar a cor (volta ao default do estilo). Hex válido = aplica.
    if (v === '' || /^#[0-9a-fA-F]{6}$/.test(v)) {
      onChange(v);
    }
  };

  const isEmpty = !value;

  return (
    <FormField label={label} description={description}>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={value || '#ffffff'}
          onChange={(e) => {
            setHexInput(e.target.value);
            onChange(e.target.value);
          }}
          className="w-12 h-12 rounded cursor-pointer border"
          style={{ borderColor: 'var(--theme-card-border)' }}
          data-testid="color-picker-swatch"
        />
        <div className="flex-1">
          <Input
            type="text"
            value={hexInput}
            onChange={handleHexChange}
            className="font-mono"
            placeholder="Padrão do estilo"
            data-testid="color-picker-hex"
          />
        </div>
        {!isEmpty && (
          <button
            type="button"
            onClick={() => { setHexInput(''); onChange(''); }}
            className="text-xs px-2 py-1 rounded-md whitespace-nowrap"
            style={{ color: 'var(--theme-text-secondary)', border: '1px solid var(--theme-card-border)' }}
            title="Remover cor (usar o padrão do estilo)"
            data-testid="color-picker-clear"
          >
            Limpar
          </button>
        )}
      </div>
    </FormField>
  );
};
